module.exports = __webpack_public_path__ + "static/media/Instagram.57967da3.svg";